export default __webpack_public_path__ + "static/media/fasting_planing@2x.53ec5691.jpg";